import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TpETLObjectTypes } from '../../etl-data-types/interfaces';
import { TpETLComponentTypeManifest } from '../interfaces';
import { TpETLPipelineComponent, TpETLDryRun, TpETLDryRunComponentResult } from '../../interfaces';
import { addDryRunObjectText } from '../../utils';
import { CONFIGPARAMTYPES } from '../../../visual-analytics/helpers/configParams';

function performDryRun(dryRun: TpETLDryRun, comp: TpETLPipelineComponent): TpETLDryRunComponentResult {
  addDryRunObjectText(dryRun, comp.outputObjectIds['result'], comp);
  return {
    abort: false,
  };
}

export const manifestETLApplyLLMText: TpETLComponentTypeManifest = {
  id: 'ApplyLLMText',
  name: 'Apply LLM on Text',
  description: 'Apply an LLM on text',
  categoryId: 'llm',
  icon: <FontAwesomeIcon icon={['fas', 'microchip-ai']} />,
  inputs: [
    {
      type: TpETLObjectTypes.TEXT,
      id: 'sourceText',
      name: 'Source text',
    },
  ],
  outputs: [
    {
      id: 'result',
      name: 'Result text',
      type: TpETLObjectTypes.TEXT,
      description: 'Response generated by the LLM.',
    },
  ],
  params: [
    {
      id: 'prompt',
      name: 'Prompt',
      description: 'Prompt to present to the LLM. You can use $text as placeholder for the input text.',
      paramType: { configParamTypeId: CONFIGPARAMTYPES.Text },
    },
  ],
  performDryRun,
};
